import React, { useCallback, useLayoutEffect } from 'react';
import { useNavigate, useAsyncValue, useRevalidator } from 'react-router-dom';

// Components
import { ShowOT } from '../../../../components/display/ShowOT/';

// Types
import { OrderDataTypes } from '../../../../components/display/ShowOT/types';
import { useRevalidateOnSync } from '../../../../offline/useRevalidateOnSync';
import { useDispatch } from 'react-redux';
import { roidOTSelected } from '../../../../state/actions/ui/roidOTSelectedGeneralView';
import { OrderType } from '../../../../types/orders';

export default function CampaignDetailed(): JSX.Element {
  const campaignData = useAsyncValue() as OrderDataTypes[];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const revalidator = useRevalidator();
  useRevalidateOnSync();

  useLayoutEffect(() => {
    if (!campaignData || campaignData.length === 0) {
      navigate('/work-orders/campaign');
      return;
    }
    dispatch(
      roidOTSelected(
        OrderType.Campaign,
        Array.isArray(campaignData[0].roid)
          ? campaignData[0].roid.join('.')
          : campaignData[0].roid,
        campaignData[0].id
      )
    );
  }, [campaignData]);

  const onReFetchData = useCallback(() => {
    revalidator.revalidate();
  }, []);

  if (!campaignData || !Array.isArray(campaignData) || campaignData.length === 0) {
    return <></>;
  }

  return (
    <ShowOT
      data={campaignData}
      revalidatorFunction={onReFetchData}
      restoreChildCardAnchor
    />
  );
}
